NtechApp.SideNav = function($snapLauncherFrom) {
    var me = this;

    this._touchClickEvent = null;

    this._$snapLauncherFrom = null;

    this._$launcher = null;
    //this._$sideNavigationBg = null;
    this._$sideNavigation = null;

    this._$closeSideNavButton = null;
    //this._$sideNavigationHeading = null;
    //this._$sideNavigationContent = null;

    this._css = {
        ids: {
            launcher: "sideNavigationLauncher",
            //sideNavigationBg: "sideNavigationBg",
            sideNavigation: "sideNavigation"
        },

        classes: {
            snapToViewportTop: "snapToViewportTop",
            openedNavigation: "openedNavigation",

            closeSideNavButton: "closeButton",
            //sideNavigationHeading: "heading",
            //sideNavigationContent: "navigation",
            //link: "link",
            //doubleLink: "doubleLink",
        }
    }

    this._construct = function () {
        me._touchClickEvent = new NtechApp.TouchClickEvent();

        me._$snapLauncherFrom = $snapLauncherFrom;

        me._$launcher = $("body").find("#" + me._css.ids.launcher);
        //me._$sideNavigationBg = $("body").find("#" + me._css.ids.sideNavigationBg);
        me._$sideNavigation = $("body").find("#" + me._css.ids.sideNavigation);
        me._$closeSideNavButton = me._$sideNavigation.find("." + me._css.classes.closeSideNavButton);
        //me._$sideNavigationHeading = me._$sideNavigation.find("." + me._css.classes.sideNavigationHeading);
        //me._$sideNavigationContent = me._$sideNavigation.find("." + me._css.classes.sideNavigationContent);

        if(NtechApp.clientSettings.isLoggedIn) {
            me._bindLoggedInEvents();
        }

        //me._updateOverlayBgHeight();
        me._bindEvents();

        NtechApp.lockScroll(me._$sideNavigation);
    }

    this._bindEvents = function () {
        var hideTimeout = null;
        $(window).on(NtechApp.SideNav.EVENT_DOCUMENT_RESIZE, function() {
            me._updateLauncherPosition();
            //me._updateOverlayBgHeight();
            //me._centrifySideNavigationContent();
        });

        $(document).on(NtechApp.SideNav.EVENT_DOCUMENT_SCROLL, function() {
            me._updateLauncherPosition();
            //me._updateOverlayBgHeight();
            //me._centrifySideNavigationContent();
        });

        me._touchClickEvent.listen(me._$launcher, function() {
            //me._$sideNavigationBg.css("display", "block");
            clearTimeout(hideTimeout);

            me._$sideNavigation.css("display", "block");
            NtechApp.dom.flushComputedStyles(me._$sideNavigation);

            me._$sideNavigation.addClass(me._css.classes.openedNavigation);
            //if(!NtechApp.clientSettings.isLoggedIn) 
            //    $("body").addClass("blurContent");

            //me._updateOverlayBgHeight();
            //me._centrifySideNavigationContent();
        });

        me._touchClickEvent.listen(me._$sideNavigation.find(".closeButtonWrap"), function() {
            //me._$sideNavigationBg.css("display", "none");
            //me._$sideNavigation.css("display", "none");
            me._$sideNavigation.removeClass(me._css.classes.openedNavigation);
            //if(!NtechApp.clientSettings.isLoggedIn) 
            //    $("body").removeClass("blurContent");

            clearTimeout(hideTimeout);
            hideTimeout = setTimeout(function() {
                me._$sideNavigation.css("display", "none");
            }, 400);
        });

        me._touchClickEvent.listen(me._$sideNavigation, "[data-eventAction='openLoginForm']", function(e) {
            e.preventDefault();
            return false;
        });
        //
        //me._touchClickEvent.listen(me._$sideNavigation.find(".items"), "a", function(event) {
        //    $(event.target).trigger("click");
        //});

        //me._touchClickEvent.listen(me._$sideNavigation, function() {
        //    me._$sideNavigation.removeClass(me._css.classes.openedNavigation);
        //});

        $(window).on("NtechApp.Router.RouteChangeStart", function() {
            me._$sideNavigation.removeClass(me._css.classes.openedNavigation);
        });

        $(window).on(NtechApp.Router.ROUTE_CHANGE_EVENT, function(event, routeName) {
            if(routeName == NtechApp.Router.ROUTES.HOME)
                me._selectItem("home");
            else if(routeName == NtechApp.Router.ROUTES.ABOUT_US)
                me._selectItem("aboutus");
            else if(routeName == NtechApp.Router.ROUTES.COLLECTIONS)
                me._selectItem("products");
            else if(routeName == NtechApp.Router.ROUTES.CONTACT_US)
                me._selectItem("contactus");
            else if(routeName == NtechApp.Router.ROUTES.CLIENTS)
                me._selectItem("clients");
            else if(routeName == NtechApp.Router.ROUTES.ACCOUNT)
                me._selectItem("account");
        });

        $(window).on(NtechApp.SideNav.EVENT_FORCE_SIDENAV_CLOSE, function() {
            me._$sideNavigation.removeClass(me._css.classes.openedNavigation);
            if(!NtechApp.clientSettings.isLoggedIn) 
                $("body").removeClass("blurContent");

            //clearTimeout(hideTimeout);
            //hideTimeout = setTimeout(function() {
            me._$sideNavigation.css("display", "none");
            //}, 400);
        });
    }

    this._bindLoggedInEvents = function() {
        me._touchClickEvent.listen(me._$launcher, ".sideEventsNotification", function() {
            me._$sideNavigation.addClass(me._css.classes.openedNavigation);
        });

        me._touchClickEvent.listen(me._$sideNavigation.find("[data-showMenu]"), function(e) {
            e.preventDefault();

            var $target = $(e.target).closest("[data-showMenu]");
            var showMenu = $target.attr("data-showMenu");

            me._$sideNavigation.find("[data-menu]").css("display", "none");
            me._$sideNavigation.find("[data-menu=" + showMenu + "]").css("display", "block");

            return false;
        });

        me._touchClickEvent.listen(me._$sideNavigation.find("[data-hideMenu]"), function(e) {
            e.preventDefault();

            me._$sideNavigation.find("[data-menu]").css("display", "none");
            me._$sideNavigation.find("[data-menu=main]").css("display", "block");

            return false;
        });

        $(window).on(NtechApp.WINDOW_EVENTS.EVENT_CHAT_MESSAGES_VIEWED, function(e, chatId) {
            var updateVal = function($counter) {
                var currVal = parseInt($counter.text(), 10);

                if(currVal == 0)
                    return false;

                currVal--;
                $counter.text(currVal);

                return true;
            };

            var wasUpdated = updateVal(me._$sideNavigation.find("[data-notViewedChatsCount]"));
            if(wasUpdated)
                updateVal(me._$launcher.find("[data-notViewedUpdatesCount]"));
        });

        $(window).on(NtechApp.WINDOW_EVENTS.EVENT_MARK_ALL_READ, function() {
            var chatsCount = me._$sideNavigation.find("[data-notViewedChatsCount]").text();
            var updatesCount = me._$launcher.find("[data-notViewedUpdatesCount]").text();
            var newUpdatesCount = parseInt(updatesCount, 10) - parseInt(chatsCount, 10);

            if(newUpdatesCount < 0)
                newUpdatesCount = 0;

            me._setNotViewedMessagesCount(0);
            me._setNotViewedUpdatesCount(newUpdatesCount);
        });

        $(window).on(NtechApp.WINDOW_EVENTS.EVENT_NOTIFICATIONS_VIEWED, function(e) {
            var notificationsCount = me._$sideNavigation.find("[data-notViewedNotificationsCount]").text();
            var updatesCount = me._$launcher.find("[data-notViewedUpdatesCount]").text();
            var newUpdatesCount = parseInt(updatesCount, 10) - parseInt(notificationsCount, 10);

            if(newUpdatesCount < 0)
                newUpdatesCount = 0;

            me._setNotViewedNotificationsCount(0);
            me._setNotViewedUpdatesCount(newUpdatesCount);
        });

        me._bindLoggedInAjaxPollingEvents();
    }

    this._bindLoggedInAjaxPollingEvents = function() {
        $(NtechApp.ajaxPolling).on(NtechApp.AjaxPolling.EVENT_ON_DATA_PULL, function(e, data) {
            me._setNotViewedMessagesCount(data.notViewedChatsCount);
            me._setNotViewedNotificationsCount(data.notViewedNotificationsCount);
            me._setNotViewedUpdatesCount(
                parseInt(data.notViewedChatsCount, 10) + parseInt(data.notViewedNotificationsCount, 10)
            );
        });
    }

    this._unbindEvents = function () {
        ;
    }

    this.destruct = function () {
        me._unbindEvents();
    }

    this._construct();
    return this;
};

NtechApp.SideNav.EVENT_DOCUMENT_SCROLL = "scroll.NtechApp.SideNavigation";
NtechApp.SideNav.EVENT_DOCUMENT_RESIZE = "resize.NtechApp.SideNavigation";
NtechApp.SideNav.EVENT_MENU_ITEM_CLICK = "NtechApp.SideNavigation.MenuItemClick";
NtechApp.SideNav.EVENT_FORCE_SIDENAV_CLOSE = "NtechApp.SideNavigation.ForceSidenavClose";

// NtechApp.SideNav.prototype._updateOverlayBgHeight = function() {
//     var newHeight = this._$sideNavigation.find(".navContent").outerHeight();
//     var vpHeight = $(window).height();

//     if(newHeight < vpHeight)
//         newHeight = vpHeight;

//     this._$sideNavigation.find(".overlayBg").css("height", newHeight + "px");
// };

NtechApp.SideNav.prototype._selectItem = function(itemName) {
    this._$sideNavigation.find(".items .item").removeClass("selected");
    this._$sideNavigation.find(".items .item[data-item=" + itemName + "]").addClass("selected");
};

NtechApp.SideNav.prototype._updateLauncherPosition = function() {
    if($(window).scrollTop() > this._$snapLauncherFrom.outerHeight() - 15)
        this._$launcher.addClass(this._css.classes.snapToViewportTop);
    else
        this._$launcher.removeClass(this._css.classes.snapToViewportTop);
};

//NtechApp.SideNav.prototype._centrifySideNavigationContent = function() {
//    var me = this;
//    $.each($("." + this._css.classes.link), function() { $(this).removeClass(me._css.classes.doubleLink); });
//
//    var headingHeight = this._$sideNavigationHeading.outerHeight() + 80;
//
//    if(this._$sideNavigationContent.outerHeight() > $(window).height() - headingHeight)
//        $.each($("." + this._css.classes.link), function() { $(this).addClass(me._css.classes.doubleLink); });
//
//    var top = ($(window).height() - this._$sideNavigationContent.outerHeight()) / 2;
//    this._$sideNavigationContent.css("top", top + "px");
//};

NtechApp.SideNav.prototype._setNotViewedMessagesCount = function(newCount) {
    var me = this;

    me._$sideNavigation.find("[data-notViewedChatsCount]").text(newCount);
    if(newCount == 0)
        me._$sideNavigation.find("[data-notViewedChatsCount]").parent().removeClass("selected");
    else
        me._$sideNavigation.find("[data-notViewedChatsCount]").parent().addClass("selected");
};

NtechApp.SideNav.prototype._setNotViewedNotificationsCount = function(newCount) {
    var me = this;

    me._$sideNavigation.find("[data-notViewedNotificationsCount]").text(newCount);
    if(newCount == 0)
        me._$sideNavigation.find("[data-notViewedNotificationsCount]").parent().removeClass("selected");
    else 
        me._$sideNavigation.find("[data-notViewedNotificationsCount]").parent().addClass("selected");
};

NtechApp.SideNav.prototype._setNotViewedUpdatesCount = function(newCount) {
    var me = this;

    me._$launcher.find("[data-notViewedUpdatesCount]").text(newCount);
    if(newCount == 0)
        me._$launcher.find("[data-notViewedUpdatesCount]").parent().removeClass("selected");
    else
        me._$launcher.find("[data-notViewedUpdatesCount]").parent().addClass("selected");
};